import {Link} from "react-router-dom";
import Button from "../../components/UI/Button";
import {checkPermission} from "../../util/auth";

const CustomerTableAction = ({id}) =>{
    return (
        <>
            {checkPermission(['CUSTOMER_DETAILS']) &&
            <Link to={"/customers/details/" + id} className={"mr_5"}>
                <Button classes={'btn_black has_border_radius'} size={'btn_sm'} text={'Details'}/>
            </Link>
            }
        </>
    );
}

export default CustomerTableAction;